import { Controller } from "@hotwired/stimulus";
import SlimSelect from "slim-select";

const i18n = {
  en: { select: "Select", search: "Search" },
  "en-US": { select: "Select", search: "Search" },
  pl: { select: "Wybierz", search: "Wyszukaj" },
  fr: { select: "Sélectionner", search: "Rechercher" },
  de: { select: "Auswählen", search: "Suchen" },
  es: { select: "Seleccionar", search: "Buscar" },
  it: { select: "Seleziona", search: "Cerca" },
  pt: { select: "Selecionar", search: "Pesquisar" },
  ru: { select: "Выбрать", search: "Поиск" },
  uk: { select: "Вибрати", search: "Пошук" },
  cs: { select: "Vybrat", search: "Hledat" },
};

export default class extends Controller {
  connect() {
    this.renderSelect();
    document.addEventListener("turbo:morph", this.renderSelect);
  }

  disconnect() {
    document.removeEventListener("turbo:morph", this.renderSelect);
    this.select?.destroy();
    this.select = null;
  }

  renderSelect = () => {
    if (!this.element.isConnected) return;

    this.select?.destroy();
    this.element.style = "";

    const { id, placeholder, visitValuePath, alwaysOpen } =
      this.element.dataset;

    const lang = (document.documentElement.lang || navigator.language).split(
      "-",
    )[0];

    const dict = i18n[lang] || i18n.en;

    const options = {
      select: this.element,
      settings: {
        maxValuesShown: 50,
        placeholderText: placeholder ?? dict.select,
        searchPlaceholder: dict.search,
        alwaysOpen: alwaysOpen === "true",
      },
      events: {},
    };

    if (options.settings.alwaysOpen) {
      options.settings.contentLocation = this.element.parentNode;
      options.settings.contentPosition = "relative";
    }

    if (id) {
      document.querySelector(`[data-id="${id}"]`).remove();

      this.element.removeAttribute("data-id");
      this.element.style.display = "inherit";
    }

    if (visitValuePath === "true") {
      options.events.beforeChange = (value) => {
        window.Turbo.visit(value[0].value);

        return false;
      };
    }

    this.select = new SlimSelect(options);
  };
}
